export const CLASSNAME = 'SunshineCard';
